import { useEffect } from "react";

/**
 * Custom hook that closes a modal when clicking outside of it
 * @param {boolean} showModal - State that controls modal visibility
 * @param {function} setShowModal - Function to update modal visibility state
 * @param {string} modalClassName - The className of the modal container to detect clicks on (default: 'modal')
 */
const useModalOutsideClick = (
  showModal,
  setShowModal,
  modalClassName = "modal"
) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if modal is open and if the click was outside modal content
      if (showModal && event.target.className === modalClassName) {
        setShowModal(false);
      }
    };

    // Add event listener
    window.addEventListener("click", handleClickOutside);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [showModal, setShowModal, modalClassName]);
};

export default useModalOutsideClick;
